export default __webpack_public_path__ + "static/media/live.703b8a95.png";